/**
 * Deutsche Bundesländer nach ISO 3166-2:DE.
 *
 * users.address_state trägt ganz überwiegend die Codes ("de-sh"), in Altzeilen
 * aber auch Klarnamen ("Schleswig-Holstein"). Anzeigen sollte deshalb immer über
 * `germanStateLabel` laufen, das beide Formen verträgt.
 */
export const GERMAN_STATE_LABELS: Record<string, string> = {
  'de-bw': 'Baden-Württemberg',
  'de-by': 'Bayern',
  'de-be': 'Berlin',
  'de-bb': 'Brandenburg',
  'de-hb': 'Bremen',
  'de-hh': 'Hamburg',
  'de-he': 'Hessen',
  'de-mv': 'Mecklenburg-Vorpommern',
  'de-ni': 'Niedersachsen',
  'de-nw': 'Nordrhein-Westfalen',
  'de-rp': 'Rheinland-Pfalz',
  'de-sl': 'Saarland',
  'de-sn': 'Sachsen',
  'de-st': 'Sachsen-Anhalt',
  'de-sh': 'Schleswig-Holstein',
  'de-th': 'Thüringen',
};

/** Auswahlliste für Selects, alphabetisch nach Klarname. */
export const GERMAN_STATE_OPTIONS = Object.entries(GERMAN_STATE_LABELS)
  .map(([code, label]) => ({ code, label }))
  .sort((a, b) => a.label.localeCompare(b.label, 'de'));

/** Klarname zu einem gespeicherten Wert — akzeptiert Code und Klarname. */
export function germanStateLabel(state?: string | null): string {
  if (!state) return '';
  return GERMAN_STATE_LABELS[state.toLowerCase()] ?? state;
}

/**
 * Gespeicherten Wert auf den ISO-Code normalisieren — akzeptiert Code und
 * Klarname. Nötig, weil Altzeilen den Namen ausgeschrieben tragen; ohne die
 * Umsetzung träfe er keine Option einer Auswahlliste.
 */
export function germanStateCode(state?: string | null): string | null {
  if (!state) return null;

  const candidate = state.toLowerCase();
  if (GERMAN_STATE_LABELS[candidate]) return candidate;

  const match = GERMAN_STATE_OPTIONS.find(o => o.label.toLowerCase() === candidate);
  return match?.code ?? null;
}
